import 'babel-polyfill'
import 'bootstrap/scss/_reboot.scss'
import Raven from 'raven-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter, Route } from 'react-router-dom'


// Default to prod unless specified in env vars
const DEVELOPMENT = process.env.NODE_ENV.toLowerCase().includes("development")
const RELEASE = process.env.REACT_APP_RELEASE

if (!DEVELOPMENT) {
    const DSN = 'https://8f06f0b61a044734988c51ff09b25e4b@sentry.io/1208855'
    Raven.config(DSN, {release: RELEASE}).install()
}

window.React = React

ReactDOM.render(
    <BrowserRouter>
        <Route path="*" component={App}/>
    </BrowserRouter>,
    document.getElementById('react-container')
)



// WEBPACK FOOTER //
// ./src/index.js